import React from "react";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { capitalize } from "lodash";
import { Grid, Typography, Button, Divider, Card, Icon } from "../ecosystem/";
import * as msgs from "../../constants/textConstants";
import { createEvent } from "ics";
import { saveAs } from "file-saver";

const OverviewConfirmation = ({
    serviceLocation,
    selectedDateTime,
    selectedVaccines,
    cities,
    selectedUsers,
    screenBreakPoint,
    history,
    isMobileSize
}) => {

    const { address1, address2, city, state, zipCode, email, mobilePhone } = serviceLocation;

    const formatCity = (cityName) => {
        if (cityName && cities) {
            let formattedCity = cities.find(c => c.value === cityName.toLowerCase())
            if (formattedCity) return formattedCity.label;
        }
        return cityName;
    }

    const extractDay = () => {
        let newDate = new Date(selectedDateTime);
        const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return weekday[newDate.getDay()]
    }

    const extractDate = () => {
        let newDate = new Date(selectedDateTime);
        const dayName = newDate.getDate();
        let monthName = newDate.getMonth() + 1;
        if (monthName < 10)
            monthName = "0" + monthName;
        return `${capitalize(Tools.getMonthName(monthName.toString()))} ${dayName}`;
    }

    const extractTime = () => {
        let newDate = new Date(selectedDateTime);
        let h = newDate.getHours();
        let m = newDate.getMinutes();
        h = h > 12 ? h - 12 : h;
        m = m < 10 ? "0" + m : m;
        return `${h.toString()}:${m.toString().padStart(2, '0')} `;
    }

    const addToCalendar = () => {

        let newDate = new Date(selectedDateTime);
        const year = newDate.getFullYear();
        const month = newDate.getMonth() + 1;
        const day = newDate.getDate();
        let hrs = newDate.getHours();
        let mins = newDate.getMinutes();
        hrs = hrs > 12 ? hrs - 12 : hrs;
        mins = mins < 10 ? 0 + mins : mins;

        let event = {
            title: 'In-Home Vaccine Appointment',
            description: 'In-Home Vaccine Appointment',
            location: `${address1}, ${address2}, ${formatCity(city)}, ${state}, ${zipCode}`,
            busyStatus: 'FREE',
            start: [year, month, day, hrs, mins],
            duration: { minutes: 30 }
        };

        createEvent(event, (error, value) => {
            const blob = new Blob([value], { type: "text/plain;charset=utf-8" });
            saveAs(blob, "in-home-vaccine-appointment.ics");
        });

       
    }

    const extractTimeSuffix = () => {
        let newDate = new Date(selectedDateTime);
        let h = newDate.getHours();
        let ispm = h >= 12;
        return `${ispm ? "pm" : "am"}`;
    }

    const print = () => {
        window.print();
    }
 
    return <>
        <div className="row overview-confirmation-wrapper">
            <div className="col-12">
                <div className="row overview-confirmation__date-time-container">
                    <div className='col-6 col-xl-4 overview-confirmation__date'>
                        <div className="overview-confirmation__section-heading">
                            <Typography
                                type="heading-01"
                                bold
                                tag="div"
                            >
                                {extractDay()}
                            </Typography>
                        </div>
                        <Typography
                            type="heading-06"
                            color={"$color-primary-a3"}
                            tag="div"
                        >
                            {extractDate()}
                        </Typography>
                    </div>
                    <div className='col-6 col-xl-4 overview-confirmation__time'>
                        <div className="overview-confirmation__section-heading">
                            <Typography
                                type="heading-01"
                                bold
                                tag="div"
                            >
                                Start Time
                            </Typography>
                        </div>

                        <Typography
                            type="heading-06"
                            color={"$color-primary-a3"}
                            tag="div"
                        >
                            {extractTime()}
                        </Typography>
                    </div>
                    <div className={"col-12 col-xl-4 overview-confirmation__add-to-cal-btn"}>
                        <Button
                            fluid
                            icon="calendar"
                            onClick={addToCalendar}
                        >
                            Add to calendar
                        </Button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-xl-8">
                        <div className="row">
                            <div className="col-12 col-lg-6 overview-confirmation__loc">
                                <div className={"overview-confirmation__section-heading"}>
                                    <Typography
                                        type="heading-01"
                                        bold
                                        tag="div"
                                    >
                                        Location
                                    </Typography>
                                </div>
                                <Typography
                                    type="body-03"
                                    color={"$color-secondary-a1"}
                                    tag="div"
                                >
                                    <div>{address1}</div>
                                    <div>{address2}</div>
                                    <div>{formatCity(city)},{state} {zipCode}</div>
                                    <div>{email}</div>
                                    <div>{mobilePhone}</div>
                                </Typography>
                            </div>

                            <div className="col-12 col-lg-6 overview-confirmation__recipients">
                                <div className={"overview-confirmation__section-heading"}>
                                    <Typography
                                        type="heading-01"
                                        bold
                                        tag="div"
                                    >
                                        Recipients
                                    </Typography>
                                </div>
                                {
                                    selectedVaccines && selectedVaccines.map((user) => {
                                        return (
                                            <div className="box" key={`${user.mrn}`}>
                                                <Typography
                                                    type="body-03"
                                                    color={"$color-secondary-a1"}
                                                    tag="div"
                                                >{user.patientName} ({user.dob})</Typography>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            <div className="col-12 col-lg-6 overview-confirmation__vaccines">
                                <div className={"overview-confirmation__section-heading-sm"}>
                                    <Typography
                                        type="heading-01"
                                        bold
                                        tag="div"
                                    >
                                        Vaccines
                                    </Typography>
                                </div>
                                <Typography
                                    type="body-03"
                                    color={"$color-secondary-a1"}
                                    tag="div"
                                >
                                    {
                                        selectedVaccines && selectedVaccines.map((user) => {
                                            const grpDetails = user.vaccines_groups.map(group => {
                                                let vaxIsChecked = group.vaccines.filter(v => v.isChecked);
                                                if (vaxIsChecked.length === 0) return null;
                                                return (<>
                                                    {
                                                        vaxIsChecked.map((vax) => (
                                                            <span className="vaccine-name-text" key={vax.axleServiceId}> <Typography
                                                                type="body-03"

                                                                color={"$color-secondary-a1"}
                                                                tag="div"
                                                            >{vax.display_name} </Typography></span>
                                                        ))
                                                    }
                                                </>)
                                            });
                                            if (grpDetails.filter(t => !!t).length === 0) return null;
                                            return (
                                                <div className="box" key={`${user.mrn}`}>
                                                    {grpDetails}
                                                </div>
                                            );
                                        })
                                    }
                                </Typography>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-xl-4">
                        <div className="row overview-confirmation__print-home-container">
                            <div className="col-12">
                                <div className="overview-confirmation__print-btn">
                                    <Button
                                        fluid
                                        icon="printer"
                                        onClick={print}
                                    >
                                        Print confirmation
                                    </Button>
                                </div>
                                <div className="overview-confirmation__home-btn">
                                    <Button
                                        fluid
                                        icon="clipboard"
                                        onClick={() => {
                                            let route = `/`;
                                            history.push(route);
                                        }}
                                    >
                                        Return to dashboard
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row overview-confirmation-card-container">
            <div className="col-12">
                <Card className="overview-confirmation-card">
                    <div className="overview-confirmation-card-heading">
                        <Typography
                            type="heading-04"
                            color={"$color-primary-a3"}
                            tag="div"
                        >
                            What’s next?
                        </Typography>
                    </div>
                    <div className="overview-confirmation-card-sub-content">
                        <Typography
                            type="body-02"
                            bold
                            tag="div"
                        >
                            Now:
                        </Typography>
                        <Typography
                            type="body-01"
                            tag="div"
                        >
                            In a few minutes, you will receive an email confirming your appointment.
                        </Typography>
                    </div>
                    <div className="overview-confirmation-card-sub-content">
                        <Typography
                            type="body-02"
                            bold
                            tag="div"
                        >
                            2 days before your appointment:
                        </Typography>
                        <Typography
                            type="body-01"
                            tag="div"
                        >
                            You will receive a reminder with all the details and other helpful information.
                        </Typography>
                    </div>
                    <div className="overview-confirmation-card-sub-content">
                        <Typography
                            type="body-02"
                            bold
                            tag="div"
                        >
                            The day of your appointment:
                        </Typography>
                        <Typography
                            type="body-01"
                            tag="div"
                        >
                            The medical professional will contact you on the day of your appointment to confirm everyone will be available at the time and place you selected. A tracking number will be provided to track their progress once they are on their way.
                        </Typography>
                    </div>
                </Card>
            </div>
        </div>
    </>



}

const mapStateToProps = state => {
    let finalConfirmationDetails = state.inHome.finalConfirmationDetails;

    return {
        serviceLocation: finalConfirmationDetails.serviceLocationContactInfo,
        selectedDateTime: finalConfirmationDetails.selectedDateTime,
        selectedVaccines: finalConfirmationDetails.selectedVaccines,
        cities: state.inHome.prefilledCities,
        selectedUsers: state.inHome.selectedUsers || [],
        screenBreakPoint: state.common.screenBreakPoint,
        history: state.session.history,
    }
}

export default connect(mapStateToProps)(OverviewConfirmation);